// StickyCTA: the floating bottom-left "growth" bubble (Book Call / 7-Day Launch).
// Disabled 2026-06-14 (Denis): rendered nothing site-wide. Kept as a no-op export so
// existing `<StickyCTA />` usages compile untouched; restore from git history to re-enable.
export function StickyCTA() {
  return null;
}
